


export default class {
    constructor(){}
}
